import {CURRENCY_SYMBOL} from "base/format/config/i18n";
import {FieldUtil} from "base/ui/section/utilities";
import {NumberUtil} from "base/format/utilities";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const TreeDataFields = ({tree, displayFees = true}) => {
    return (
        <Grid container columnSpacing={2}>
            <Grid item xs={6}>
                {FieldUtil.getSectionField(
                    "Altura",
                    NumberUtil.formatDecimal(tree.height),
                    "m"
                )}
                {FieldUtil.getSectionField(
                    "Volume",
                    NumberUtil.formatDecimal(tree.volume),
                    "m³"
                )}
            </Grid>
            <Grid item xs={6}>
                {FieldUtil.getSectionField(
                    "Diámetro AP",
                    NumberUtil.formatDecimal(tree.diameter),
                    "m"
                )}
                {tree.cutting
                    ? FieldUtil.getSectionField("Nº de toros", tree.number_of_logs)
                    : null}
            </Grid>

            <Grid item xs={6}>
                {tree.felling && displayFees
                    ? FieldUtil.getSectionField(
                          "Taxa de abate",
                          NumberUtil.formatCurrency(tree.felling_fee, false),
                          `${CURRENCY_SYMBOL}/m³`
                      )
                    : null}
                {tree.cutting && displayFees
                    ? FieldUtil.getSectionField(
                          "Taxa de serragem",
                          NumberUtil.formatCurrency(tree.cutting_fee, false),
                          `${CURRENCY_SYMBOL}/toro`
                      )
                    : null}
            </Grid>
            <Grid item xs={6} sx={{marginTop: "auto"}}>
                {tree.felling && displayFees
                    ? FieldUtil.getSectionField(
                          "Valor de abate",
                          NumberUtil.formatCurrency(tree.felling_price, false),
                          CURRENCY_SYMBOL
                      )
                    : null}
                {tree.cutting && displayFees
                    ? FieldUtil.getSectionField(
                          "Valor de serragem",
                          NumberUtil.formatCurrency(tree.cutting_price, false),
                          CURRENCY_SYMBOL
                      )
                    : null}
            </Grid>
            <Grid item xs={12}>
                <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{lineHeight: {xs: 1.5, sm: 1.25}}}
                >
                    Observações:
                </Typography>
                <Box
                    sx={{
                        width: "100%",
                        border: 1,
                        borderRadius: 1,
                        borderStyle: "solid",
                        borderColor: "grey.300",
                        backgroundColor: "grey.100",
                        p: 1,
                        fontSize: 14,
                        whiteSpace: "pre-line",
                        lineHeight: 1.5,
                        maxHeight: "3.6em",
                        overflowY: "auto",
                    }}
                >
                    {tree?.comments || (
                        <Typography
                            component="span"
                            sx={{fontSize: 14, fontStyle: "italic"}}
                        >
                            —
                        </Typography>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default TreeDataFields;
